(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/leia-default-events.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/leia-default-events.js');
"use strict";

const _svs$tur$pay = svs.tur.pay,
  accountServices = _svs$tur$pay.account_services,
  dialogs = _svs$tur$pay.dialogs;
const defaultEventsLeiaFactory = _ref => {
  let _ref$isReplay = _ref.isReplay,
    isReplay = _ref$isReplay === void 0 ? false : _ref$isReplay,
    ticketInfo = _ref.ticketInfo,
    voucherCode = _ref.voucherCode,
    wagerId = _ref.wagerId,
    _ref$isPurchaseDisabl = _ref.isPurchaseDisabled,
    isPurchaseDisabled = _ref$isPurchaseDisabl === void 0 ? false : _ref$isPurchaseDisabl,
    onClose = _ref.onClose,
    _ref$isEInstant = _ref.isEInstant,
    isEInstant = _ref$isEInstant === void 0 ? false : _ref$isEInstant,
    _ref$isDemo = _ref.isDemo,
    isDemo = _ref$isDemo === void 0 ? false : _ref$isDemo;
  let errorDialogShown = false;
  const getAccountBalanceParams = _ref2 => {
    let isPayAfterDepositEnabled = _ref2.isPayAfterDepositEnabled,
      price = _ref2.price,
      product = _ref2.product,
      ticketInfo = _ref2.ticketInfo;
    if (!isPayAfterDepositEnabled || !product) return {
      price
    };
    return {
      price,
      product,
      isAutoPayAfterDeposit: true,
      title: "Du beh\xF6ver s\xE4tta in pengar f\xF6r att kunna betala din ".concat(ticketInfo.name),
      message: 'Observera att spelet inte går att annullera.'
    };
  };
  const getConfirmPaymentOptions = _ref3 => {
    let price = _ref3.price,
      shouldPayAfterDeposit = _ref3.shouldPayAfterDeposit,
      accountBalance = _ref3.accountBalance,
      ticketInfo = _ref3.ticketInfo;
    return {
      price,
      accountBalance,
      title: "".concat(shouldPayAfterDeposit ? 'Din insättning är klar.<br>' : '', "Vill du betala en ").concat(ticketInfo.name, " f\xF6r ").concat(price, " kr?"),
      messages: ['Observera att spelet inte går att annullera.']
    };
  };
  const getHasAfterPayParam = () => {
    const afterPay = svs.utils.paramHandler.get({
      key: 'afterpay'
    }).value;
    svs.utils.paramHandler.remove({
      key: 'afterpay'
    });
    return Boolean(afterPay);
  };
  return [{
    eventName: 'HAS_BET',
    handler: () => {
      !isDemo && svs.components.account_balance && svs.components.account_balance.get(true);
    }
  }, {
    eventName: 'HANDLE_PREBET',
    handler: e => {
      const _e$detail = e.detail,
        resolve = _e$detail.resolve,
        reject = _e$detail.reject,
        stake = _e$detail.stake,
        demo = _e$detail.demo;
      const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils,
        currencyFormatter = _svs$ticketgames$tick.currencyFormatter,
        getAccountBalanceAfterChange = _svs$ticketgames$tick.getAccountBalanceAfterChange;
      const price = svs.utils.format.CurrencyFromJupiterString(currencyFormatter(stake.value));
      const hasAfterDepositParam = getHasAfterPayParam();
      const isPayAfterDepositEnabled = svs.core.detect.feature('ft-tickets-pay-after-deposit') && !isEInstant;
      const shouldPayAfterDeposit = hasAfterDepositParam && isPayAfterDepositEnabled;
      if (demo || isDemo || voucherCode) {
        var _gameloaderHelper$ins;
        (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || _gameloaderHelper$ins.bridgeFrame.focus();
        return resolve();
      } else if (isPurchaseDisabled) {
        reject();
        return onClose();
      }
      if (wagerId && wagerId.toLowerCase() !== 'pending') {
        svs.ticketgames.ticketUtility.logger.warn("wager with wagerId ".concat(wagerId, " was not found for game ").concat(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.type));
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          type: svs.ui.dialog.type.ERROR,
          icon: 'exclamation-sign',
          title: 'Fel',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: 'Spelet kunde inte hittas.'
          }],
          actions: [{
            title: 'Okej',
            callback: (e, forms, dialog) => {
              dialog.close();
              onClose();
            }
          }]
        }));
        reject();
        return;
      }
      const product = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding;
      let accountBalance;
      let latestAccountBalance;
      const calls = [{
        in: () => ({
          price,
          product
        }),
        fn: accountServices.playerSession
      }, {
        fn: accountServices.playerSuspension
      }, {
        in: () => ({
          spelpausFlags: [accountServices.playerSpelpaus.CONSTANTS.QUICK_GAMES]
        }),
        fn: accountServices.playerSpelpaus
      }, {
        fn: accountServices.dayTimeLimit
      }, {
        in: () => getAccountBalanceParams({
          isPayAfterDepositEnabled,
          price,
          ticketInfo,
          product
        }),
        fn: accountServices.accountBalance,
        out: args => {
          var _args = args;
          accountBalance = _args.accountBalance;
          return _args;
        }
      }, {
        fn: accountServices.playerDepositLimits
      }, ...(shouldPayAfterDeposit ? [{
        fn: _ref4 => {
          let next = _ref4.next;
          resolve();
          next();
        }
      }, {
        fn: _ref5 => {
          let next = _ref5.next;
          return getAccountBalanceAfterChange({
            next
          });
        },
        out: args => {
          var _args2 = args;
          latestAccountBalance = _args2.latestAccountBalance;
          return _args2;
        }
      }, {
        in: () => ({
          productName: ticketInfo.name,
          totalCost: price,
          accountBalance: latestAccountBalance,
          brand: product
        }),
        fn: svs.ticketgames.ticketUtility.utils.afterPayment
      }] : [{
        in: () => getConfirmPaymentOptions({
          price,
          shouldPayAfterDeposit: hasAfterDepositParam,
          ticketInfo,
          accountBalance
        }),
        fn: dialogs.confirmPayment
      }, {
        fn: _ref6 => {
          let next = _ref6.next;
          resolve();
          next();
        }
      }])];
      const cancel = () => {
        var _e$detail2;
        reject();
        if (e !== null && e !== void 0 && (_e$detail2 = e.detail) !== null && _e$detail2 !== void 0 && _e$detail2.delay) {
          setTimeout(() => onClose(), e.detail.delay);
        } else {
          onClose();
        }
      };
      svs.tur.pay.initPay({
        calls,
        cancel
      });
    }
  }, {
    eventName: 'HAS_CLAIMED',
    handler: data => {
      if (data !== null && data !== void 0 && data.detail && !isDemo && !isReplay) {
        var _data$detail, _data$detail2;
        svs.ticketgames.ticketUtility.utils.tracking.ticketCompleted(ticketInfo.name);
        svs.ticketgames.ticketUtility.utils.tracking.ticketResult(ticketInfo.name, (_data$detail = data.detail) === null || _data$detail === void 0 || (_data$detail = _data$detail.wonAmount) === null || _data$detail === void 0 ? void 0 : _data$detail.value);
        if ((_data$detail2 = data.detail) !== null && _data$detail2 !== void 0 && (_data$detail2 = _data$detail2.data) !== null && _data$detail2 !== void 0 && (_data$detail2 = _data$detail2.revelationData) !== null && _data$detail2 !== void 0 && _data$detail2.autoCorrected) {
          const autoCorrected = data.detail.data.revelationData.autoCorrected;
          svs.ticketgames.ticketUtility.logger.info("CorrectionMethod (".concat(ticketInfo.type, "): ").concat(autoCorrected ? 'AUTO' : 'MANUAL'));
        }
      }
    }
  }, {
    eventName: 'TAG',
    handler: data => {
      if (data.detail) {
        const _data$detail3 = data.detail,
          event = _data$detail3.event,
          _data$detail3$request = _data$detail3.requestResponse,
          requestResponse = _data$detail3$request === void 0 ? {} : _data$detail3$request,
          eventType = _data$detail3.eventType,
          gameName = _data$detail3.gameName;
        if (event === 'getItgTicket' && eventType === 'requestResponse' && requestResponse.data.length >= 1) {
          var _requestResponse$data;
          const itgTicketType = (_requestResponse$data = requestResponse.data[0]) === null || _requestResponse$data === void 0 ? void 0 : _requestResponse$data.serviceName;
          if (itgTicketType !== gameName) {
            svs.ticketgames.ticketUtility.logger.error("ticketType (".concat(gameName, ") does not match fetched ItgTicket (").concat(itgTicketType, ")"));
            svs.tur.apierrors.showErrorMessage({
              onConfirm: onClose,
              response: {
                error: {
                  code: 0
                }
              }
            });
          }
        }
      }
    }
  }, {
    eventName: 'TAG',
    handler: _ref7 => {
      let _ref7$detail = _ref7.detail,
        detail = _ref7$detail === void 0 ? {
          eventType: '',
          event: '',
          gameName: null
        } : _ref7$detail;
      const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils.constants.leia.errors,
        types = _svs$ticketgames$tick2.types,
        events = _svs$ticketgames$tick2.events;
      const isErrorType = types.find(e => {
        var _detail$eventType;
        return e === ((_detail$eventType = detail.eventType) === null || _detail$eventType === void 0 ? void 0 : _detail$eventType.toLowerCase());
      });
      const isErrorEvent = events.find(e => {
        var _detail$event;
        return e.toLowerCase() === ((_detail$event = detail.event) === null || _detail$event === void 0 ? void 0 : _detail$event.toLowerCase());
      });
      if (isErrorType) {
        const msg = "LEIA ERROR - eventType: ".concat(detail.eventType, ", error: ").concat(detail.event, ", gameCode: ").concat(detail.gameName, ", gameMode: ").concat(isDemo ? 'DEMO' : 'NORMAL');
        if (isErrorEvent && !errorDialogShown) {
          var _detail$requestRespon;
          const willBeHandledByOpenPop = (detail === null || detail === void 0 || (_detail$requestRespon = detail.requestResponse) === null || _detail$requestRespon === void 0 || (_detail$requestRespon = _detail$requestRespon.data) === null || _detail$requestRespon === void 0 ? void 0 : _detail$requestRespon.code) === 'BetError.999';
          !willBeHandledByOpenPop && setTimeout(() => {
            if (!svs.ui.dialog.api.isBlocking) {
              svs.tur.apierrors.showErrorMessage({
                onConfirm: onClose,
                fallbackTitle: 'Tekniskt fel',
                fallbackMessage: 'Ett tekniskt fel har inträffat. Vänligen försök igen senare.',
                response: {
                  error: {
                    code: 0
                  }
                }
              });
            }
          }, 200); 
          errorDialogShown = true; 
          svs.ticketgames.ticketUtility.logger.error(msg);
        } else {
          svs.ticketgames.ticketUtility.logger.warn(msg, " - event not handled: ".concat(JSON.stringify(detail)));
        }
      }
    }
  }];
};
setGlobal('svs.ticketgames.ticketUtility.utils.defaultEventsLeiaFactory', defaultEventsLeiaFactory);

 })(window);